import { Grid, GridItem, Skeleton, AspectRatio } from '@chakra-ui/react'
import type { ReactElement } from 'react'
import { useState } from 'react'
import useColCountObserver from '../../../../hooks/useColCountObserver'

const FileGridLoader = ({scrollEl}: {
  scrollEl: HTMLDivElement | null
}): ReactElement | null => {
  const [colCount, setColCount] = useState(4)
  useColCountObserver(scrollEl, setColCount)

  return (
    <Grid
      gridTemplateColumns={`repeat(${colCount}, minmax(10px, 1fr))`}
      columnGap={6}
      rowGap={6}
      width="100%"
    >
      {Array.from({ length: colCount }).map((_, idx) => (
        <GridItem key={idx} borderRadius="8px" overflow="hidden">
          <AspectRatio width="100% " ratio={1}>
            <Skeleton height="100%" />
          </AspectRatio>
          <Skeleton height="64px"/>
        </GridItem>
      ))}
    </Grid>
  )
}

export default FileGridLoader
